import React from 'react';
import { useFormikContext } from 'formik';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Grid } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
const DatePickerComponent = ({ name, label, value, error, required, helperText, disabled= false, disableFuture=false, hideIcon=false }) => {
  const { setFieldValue } = useFormikContext();

  return (
    
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container>
        <KeyboardDatePicker
          clearable
          selected={(value && new Date(value)) || null}
          onChange={val => setFieldValue(name, val)}
          name={name}
          autoOk
          value={value}
          required={required}
          // margin="dense"
          // inputVariant="outlined"
          format="MM/dd/yyyy"
          placeholder="MM/DD/YYYY"
         fullWidth
          InputLabelProps={{
            shrink: true,
            // style: { color: "#0000008A" },
          }}
          label={label}
          error={error}
          helperText={helperText}
          disabled={disabled}
          disableFuture={disableFuture}
          keyboardIcon={hideIcon ? null : <EventIcon/>}
        />
      </Grid>
    </MuiPickersUtilsProvider>
 
  );
};

export default DatePickerComponent;

